import React, { Fragment } from 'react';
import { getImageUrl, ListingImageSizes } from '@domain-group/fe-allhomes-library';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { BedIcon, BathIcon, ParkingIcon } from '@domain-group/fe-co-icon';
import * as styles from './large-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var renderFeature = function renderFeature(SelectedIcon, title) {
  var featureValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (featureValue) {
    return ___EmotionJSX("span", {
      css: styles.feature
    }, ___EmotionJSX("span", {
      css: styles.featureText
    }, featureValue), ___EmotionJSX(SelectedIcon, {
      title: title,
      size: "small"
    }));
  }
  return false;
};
var LargeCard = _ref => {
  var listing = _ref.listing,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Property of the Week' : _ref$title;
  var displayStreet = () => {
    if (listing.newDevelopment && listing.propertyName) {
      return "".concat(listing.propertyName, ",");
    }
    if (listing.address.street && listing.address.street.length > 0) {
      return "".concat(listing.address.street, ",");
    }
    return ___EmotionJSX(Fragment, null, "\xA0");
  };
  return ___EmotionJSX("div", {
    css: styles.listingCard
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: getImageUrl(listing.image.highRes, ListingImageSizes.LARGE),
    alt: ""
  }), ___EmotionJSX("div", {
    css: styles.infoSection
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.listingInfo
  }, ___EmotionJSX("span", {
    css: styles.price
  }, listing.formattedPrice), ___EmotionJSX("a", {
    css: styles.addressContainer,
    href: listing.url,
    onClick: onClick
  }, ___EmotionJSX("span", {
    css: styles.addressLine
  }, displayStreet(), " ", listing.address.suburb, " ", listing.address.state, ' ', listing.address.postcode)), ___EmotionJSX("div", {
    css: styles.featureGroup
  }, renderFeature(BedIcon, 'Bedrooms', listing.formattedBeds), renderFeature(BathIcon, 'Bathrooms', listing.formattedBaths), renderFeature(ParkingIcon, 'Parking', listing.formattedParking))), ___EmotionJSX("div", {
    css: styles.agentInfo
  }, ___EmotionJSX(Avatar, {
    css: styles.agentPhoto,
    imageUrl: listing.agent.agentPhoto,
    isBordered: true,
    colorScheme: "light"
  }), ___EmotionJSX("span", {
    css: styles.agentDetails
  }, ___EmotionJSX("span", {
    css: styles.agentName
  }, listing.agent.agentName), ___EmotionJSX("img", {
    src: listing.agent.agencyLogo,
    css: styles.agencyLogo,
    alt: ""
  })))));
};
export { LargeCard };